import { SystemIcon } from "@storeblocks/icon";
import { DetailedVehicle } from "Api/registration";
import { useTexts } from "Components/TextContext";
import { Button as CommonButtonText } from "Components/TextContext/commonComponentEnums";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { MainPath } from "Constants/constants";
import { buttonNextTrackId } from "Utils/analytics";
import { getCartIdFromCookie } from "Utils/cookies/cookiesUtil";
import { getLocationOrigin } from "Utils/generalUtils";
import React from "react";
import { useHistory } from "react-router-dom";
import { STOREBRAND_COMPANY_CODE } from "../hooks";

export const ActionButton = (props: {
  vehicle: DetailedVehicle & { isAddedToCart: boolean };
  selectVehicle: (vehicle: DetailedVehicle) => void;
}): JSX.Element => {
  const { vehicle, selectVehicle } = props;
  const history = useHistory();
  const { getText } = useTexts();

  if (vehicle.companyCode === STOREBRAND_COMPANY_CODE) {
    const domain = getLocationOrigin();

    return (
      <ThemedButton
        id={buttonNextTrackId("see-insurance")}
        type="button"
        variant="text"
        onClick={() =>
          window.open(
            `${domain}/mine-forsikringssider/kjoeretoey/${vehicle.regNumber}`,
            "_blank",
          )
        }
        trackId={buttonNextTrackId("see-insurance")}
        iconRight="arrow-right"
      >
        {getText("carform.button.seeinsurance")}
      </ThemedButton>
    );
  }

  if (vehicle.isAddedToCart) {
    return (
      <ThemedButton
        id={buttonNextTrackId("see-cart")}
        type="button"
        variant="text"
        trackId={buttonNextTrackId("see-cart")}
        onClick={() =>
          history.push(`/${MainPath.OFFER}/${getCartIdFromCookie()}`)
        }
        paddingRight="0px"
      >
        {getText(CommonButtonText.SEE_CART)}{" "}
        <SystemIcon name="arrow-right" marginLeft="16px" />
      </ThemedButton>
    );
  }

  return (
    <ThemedButton
      id={buttonNextTrackId("check-price")}
      type="submit"
      onClick={() => {
        selectVehicle(vehicle);
      }}
      trackId={buttonNextTrackId("check-price")}
    >
      {getText(CommonButtonText.CHECK_PRICE)}
    </ThemedButton>
  );
};
